import crossFetch from 'cross-fetch';
import { CdepApi } from './CdepApi';
import { ResponseError } from '@backstage/errors';
import { cdepStatusResultSchema, cdepPullRequestResultSchema } from '../types';

// these are isomorphic types that don't require @backstage/core-plugin-api
type DiscoveryApi = { getBaseUrl(pluginId: string): Promise<string> };
type FetchApi = { fetch: typeof fetch };

export class CdepClient implements CdepApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  public constructor(deps: {
    discoveryApi: DiscoveryApi;
    fetchApi?: FetchApi;
  }) {
    const { discoveryApi, fetchApi } = deps;
    this.discoveryApi = discoveryApi;
    this.fetchApi = fetchApi ?? { fetch: crossFetch };
  }

  public async getStatusResult() {
    const baseUrl = await this.getBaseUrl();
    const response = await this.fetchApi.fetch(`${baseUrl}/status`);
    if (response.status === 201) {
      // cdep status data is still pre-fetching on the server
      return null;
    }
    if (!response.ok) {
      throw await ResponseError.fromResponse(response);
    }
    const data = await response.json();
    return cdepStatusResultSchema.parse(data);
  }

  public async getPullRequestResult(id: number) {
    const baseUrl = await this.getBaseUrl();
    const response = await this.fetchApi.fetch(
      `${baseUrl}/pull-requests/${id}`,
    );
    if (!response.ok) {
      throw await ResponseError.fromResponse(response);
    }
    const data = await response.json();
    return cdepPullRequestResultSchema.parse(data);
  }

  private async getBaseUrl() {
    return this.discoveryApi.getBaseUrl('cdep');
  }
}
